// Meta Pixel utility for tracking events
declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '1588595258841964'

export function initMetaPixel() {
  if (typeof window === 'undefined') return // Initialize Facebook Pixel
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    // Use document.head.appendChild instead of insertBefore to avoid null reference
    b.head.appendChild(t)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(
  contentName?: string,
  value?: number,
  currency?: string,
) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: contentName || 'Hábitos Atómicos Espirituales',
      content_type: 'product',
      value: value || 199,
      currency: currency || 'MXN',
    })
  }
}
